// extracted by mini-css-extract-plugin
export default {"contentC":"App_contentC__2o5A5","bodyC":"App_bodyC__R-UNw"};